import { render, staticRenderFns } from "./WarningSaveAndCloseBulkSend.vue?vue&type=template&id=012e29a1&lang=pug"
import script from "./WarningSaveAndCloseBulkSend.vue?vue&type=script&lang=js"
export * from "./WarningSaveAndCloseBulkSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports